<template>
  <div class="individualReport">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <span class="mr10 fs14 color-666">{{
            $t("views.Analysisreport.admTrackReport.51nbh6yjwc22")
          }}</span>
          <div class="select-box" style="width: 300px">
            <el-date-picker
              style="width: 300px"
              v-model="filterList.rangTime"
              type="daterange"
              @change="search"
              :range-separator="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fmf00')
              "
              value-format="yyyy-MM-dd"
              :start-placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fmzw0')
              "
              :end-placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fnis0')
              "
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="filterCourseCat"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursecat_id"
              clearable
              filterable
              :placeholder="$t('Customersmanage.dac')"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.courseCatList"
                :key="index"
                :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                :value="item.coursecat_id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
// import reportType from "@/components/report/reportType";
import reportPageTemp from "@/components/report/tableTemplate";
import http from "../analysisreport.js";

export default {
  name: "analysisreport-individualReport",
  data() {
    return {
      pickerOptions: {},
      reportParams: {
        wayString: "marketerClientReport", //传递到子组件的方法名称
        Title: this.$t("Analysisreport.ad"),
      },

      filterList: {
        rangTime: "",
        coursetypeList: [],
        courseCatList: [],
      },
      filter: {
        coursetype_id: "",
        coursecat_id: "",
        starttime: "",
        endtime: "",
      },
    };
  },
  components: {
    reportPageTemp,
  },
  created() {
    this.filterList.rangTime = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    this.filter.starttime = this.$Common.getAppointedDate(2, 0).startDate;
    this.filter.endtime = this.$Common.getAppointedDate(2, 0).endDate;
    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();
  },
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.filterList.coursetypeList = res.data.data.list;
          } else {
            this.filterList.coursetypeList = [];
          }
        });
    },
    filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.search();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    search() {
      this.filter.starttime = this.filterList.rangTime
        ? this.filterList.rangTime[0]
        : "";
      this.filter.endtime = this.filterList.rangTime
        ? this.filterList.rangTime[1]
        : "";
      this.$refs.reportPageTemp.search();
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../analysisreport.less");
.individualReport {
  // height: 100vh;
  font-size: 20px;
}
</style>
